import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';
import { RoleService } from '../services/role.service';

@Component({
  selector: 'app-frontend',
  templateUrl: './frontend.component.html',
  styleUrls: ['./frontend.component.scss']
})

export class FrontendComponent implements OnInit {
  public rememberMe: boolean = false;
  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenStorageService: TokenStorageService,
    private roleService: RoleService
  ) {

  }

  ngOnInit(): void {
    this.roleService.setCurrentActiveRoute2(this.router.url);
    this.roleService.setCurrentActiveRoute(this.router.url);
  }

}
